import { useMutation, useQuery, useQueryClient, type QueryClient } from "@tanstack/react-query";
import { projetoRascunhoApi } from "@/services/projeto-rascunho-api";

const CANCELLED_KEY = ["projetos", "rascunhos-cancelados"] as const;

function invalidateDraftViews(queryClient: QueryClient) {
  return Promise.all([
    queryClient.invalidateQueries({ queryKey: ["controle-projetos"] }),
    queryClient.invalidateQueries({ queryKey: ["v3", "projetos"] }),
    queryClient.invalidateQueries({ queryKey: ["v3", "projeto"] }),
    queryClient.invalidateQueries({ queryKey: ["vagas-column"] }),
    queryClient.invalidateQueries({ queryKey: ["finance", "projetos-elegiveis"] }),
    queryClient.invalidateQueries({ queryKey: CANCELLED_KEY }),
  ]);
}

/** Batch lookup for the Aprovado column: one request for the loaded page, never one per card. */
export function useRascunhosCancelados(vagaIds: string[], enabled: boolean) {
  const sorted = [...vagaIds].sort();
  return useQuery({
    queryKey: [...CANCELLED_KEY, sorted],
    queryFn: () => projetoRascunhoApi.cancelledByVaga(sorted),
    enabled: enabled && sorted.length > 0,
    staleTime: 60 * 1000,
    select: (data) => new Map(data.itens.map((item) => [item.vaga_id, item])),
  });
}

export function useCancelarRascunho() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: projetoRascunhoApi.cancel,
    onSuccess: () => invalidateDraftViews(queryClient),
  });
}

export function useVoltarParaRascunho() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: projetoRascunhoApi.restore,
    onSuccess: () => invalidateDraftViews(queryClient),
  });
}
